import type { VFC } from 'react'
import type { ScreenComponentProps } from '../renderer'
import { cloneElement, useCallback } from 'react'

export type DefaultActivateScreenProps = {}
const DefaultActivateScreen: VFC<ScreenComponentProps & ScreenComponentProps> = ({
  // title,
  // description,
  // primaryButton,
  // state,
  children,
}) => {

  const renderChildInformation = useCallback((children: any) => {
    return children?.props?.children.map((child: any) => {
      return cloneElement(child, { ...child.props })
    })
  }, [])
  return <div className='tw-flex tw-flex-1 cm-m-auto cm-w-[1000px] tw-align-middle tw-h-full'>
    <div className='tw-flex tw-flex-1 tw-flex-col'>
      {renderChildInformation(children)}
    </div>
  </div>
}

export default DefaultActivateScreen
